// Import Dependencies
import PropTypes from "prop-types";
import { forwardRef } from "react";
import clsx from 'clsx'

// Local Imports
import { Box } from "components/ui";
import { useThemeContext } from "app/contexts/theme/context";

// -------------------------------------------------------------

const Card = forwardRef((props, ref) => {
  const { cardSkin } = useThemeContext();

  const { skin = cardSkin, children, className, ...rest } = props;

  return (
    <Box
      ref={ref}
      className={clsx(
        "card rounded-lg",
        skin &&
          skin !== "none" && [
            skin === "bordered" &&
              "border border-gray-200 dark:border-dark-600 print:border-0",
            skin === "shadow" &&
              "bg-white shadow-soft dark:bg-dark-700 dark:shadow-none print:shadow-none",
          ],
        className,
      )}
      {...rest}
    >
      {children}
    </Box>
  );
});

Card.displayName = "Card";

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  skin: PropTypes.oneOf(["none", "bordered", "shadow"]),
};

const CardBody = forwardRef((props, ref) => {
  const { children, className, ...rest } = props;
  return (
    <div ref={ref} className={clsx("p-5", className)} {...rest}>
      {children}
    </div>
  );
});
CardBody.displayName = "CardBody";
CardBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const CardHeader = forwardRef((props, ref) => {
  const { children, className, ...rest } = props;
  return (
    <div
      ref={ref}
      className={clsx(
        "px-5 py-4 border-b border-gray-200 dark:border-dark-600",
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
});
CardHeader.displayName = "CardHeader";
CardHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const CardTitle = forwardRef((props, ref) => {
  const { children, className, ...rest } = props;
  return (
    <h3
      ref={ref}
      className={clsx("text-lg font-semibold text-gray-900 dark:text-white", className)}
      {...rest}
    >
      {children}
    </h3>
  );
});
CardTitle.displayName = "CardTitle";
CardTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export { Card, CardBody, CardHeader, CardTitle };
